import { Component, ViewChild, ApplicationRef } from '@angular/core';
import { NavParams, NavController, Platform, Events, MenuController, Content } from 'ionic-angular';
import { AppScreen } from '../../providers/config/config';
import { AppState } from '../../config/state';
import { LoginProvider } from '../../providers/login/login';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { duration } from 'moment';
import { PageProvider } from '../../providers/page/page';
import { HidScannerProvider } from '../../providers/hid-scanner/hid-scanner';
import { AnalyticsProvider } from '../../providers/analytics/analytics';

@Component({
  selector: 'page-screen',
  templateUrl: 'screen.html',
})
export class ScreenPage {
  @ViewChild('screenEl') screenEl;
  @ViewChild(Content) content: Content;
  private fullscreen: boolean;
  private clock: boolean;
  private screenData: AppScreen;
  private layout: Array<Array<any>>;
  private menuSide = "right";
  private hidSubscription: any;
  private _handler: Function;
  checkForLogout: boolean = false;
  viewType: any;
  isRootPage: boolean = false;
  enableBackButton: boolean = true;
  sharedScreen: boolean;
  locationName: string;
  wideScreen: boolean;
  headerLogo: string;
  constructor(public navParams: NavParams, private state:AppState, private navCtrl : NavController, private login : LoginProvider, private platform : Platform, private clientProvider: ClientDetailsProvider, private events :Events, private menuCtrl : MenuController, private sounds : SoundsProvider, private ref: ApplicationRef, private toast : ToastAlertsProvider, private pages : PageProvider, private hidScanner: HidScannerProvider, private analytics:AnalyticsProvider) {
    window.onresize = (e) =>
    {
      this.wideScreen = this.platform.width() > 600;
    };
    this.wideScreen = this.platform.width() > 600;
    this.sharedScreen = this.state.sharedScreen;
    this.viewType = this.state.mode;
    this.screenData = this.navParams.data.screenData;
    // console.log(this.state)

  this._handler = () =>{
		this.content.resize();
  };
	this.events.subscribe('patronLoggedIn', this._handler);
  this.events.subscribe('homeScrollToTop', ()=>{
    this.content.scrollToTop();
  })

	window.onresize = (e) =>
    {
      setTimeout(() => {
        if (this.platform.width() > 600) {
          this.wideScreen = true;
        } else if (this.platform.isLandscape()) {
          this.wideScreen = true;
        } else {
          this.wideScreen = false;
        }
        if (this.screenData.name==='home') {
          this.ref.tick();
        }
      }, 225)

    };

    this.layout = [];
    this.fullscreen = this.screenData && this.screenData.settings && this.screenData.settings.fullscreen ? this.screenData.settings.fullscreen : false;
    this.clock = this.screenData && this.screenData.settings && this.screenData.settings.clock ? this.screenData.settings.clock : false;
    this.state.clockEnabledOnScreen = this.clock;
    // console.log(this.screenData);
    if (this.screenData.settings && this.screenData.settings.requireLogin){
      this.login.requireLogin((patron) => {
      });
    }
    if (this.state.headerLogo) {
      this.clientProvider.load().then((res) => {
        this.headerLogo = `https://${res.keyword}.libnet.info/images/logos/${res.keyword}/${this.state.headerLogo}`;
      });
    }
    this.navCtrl.length() <= 1 ? this.isRootPage = true : this.isRootPage = false;
    this.navCtrl.length() <= 0 ? this.enableBackButton = false : this.enableBackButton = true;
    if (this.state.burgerMenu) {
      this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
    }
    if(this.screenData.layout && this.screenData.layout.length>0){
      const blocksById=this.screenData.blocks.reduce((ret, block)=>{
        ret[block.id]=block;
        return ret;
      }, {});
      // console.log(this.screenData);
      this.screenData.layout.forEach(row=>{
        let layoutRow = [];
        row.forEach(cell=>{
          if(Array.isArray(cell)){
            let nestedRow = [];
            cell.forEach(cell=>{
              if(blocksById[cell.id]){
                nestedRow.push({block:blocksById[cell.id], attributes: cell.attributes});
              }
            });
            layoutRow.push({row:nestedRow});
          }else if(blocksById[cell.id]){
            layoutRow.push({block:blocksById[cell.id], attributes: cell.attributes});
          }
        });
        this.layout.push(layoutRow);
      });
    }else{
      this.layout.push([]);
      this.screenData.blocks.forEach(block=>{
        this.layout[0].push({block:block, attributes:[]});
      });
    }
    // console.log(this.screenData.name);
  }
  getLayout(row){

  }
  ngAfterViewInit(){
    if(this.screenData && this.screenData.css){
      Object.keys(this.screenData.css).forEach((key) => {
        let value = this.screenData.css[key];
        // this.screenEl.nativeElement.style[key]=value;
        this.screenEl.nativeElement.style.setProperty(key, value, 'important');
      });
      if (this.screenData.settings && this.screenData.settings.isHomeScreen) {
        this.state.homeScreen = this.navCtrl.getActive().index;
      }
    }
    this.sounds.playSoundOnButtonClick();
    // this.state.currentScreen = this.screenData;
    // console.log(this.state)
  }
  ngOnInit(): void {

  }
  ionViewWillLeave(){
    this.events.publish('closeKeyboard');
    if (this.state.autologoutPosition > 0 && this.navCtrl.length() === this.state.autologoutPosition && this.state.patron && this.state.sharedScreen){
      // this.checkForLogout = true;
      // this.ionViewCanLeave();
      console.log('auto logging out');
      this.login.logout();
      // console.log('logged out')
    }
    console.log('unsub from scanner')
    if (this.hidSubscription) this.hidSubscription.unsubscribe();
    this.hidScanner.stop();
  }
  homeScreenScanning(){
    this.hidSubscription = this.hidScanner.scan.subscribe(value => {
      if(this.state.homeScanActive) {
        const page = this.pages.getPage(this.state.scanIntoPage);
        if (page) this.navCtrl.push(page, {scan: value});
      }
    });
    this.state.homeScanActive = true;
    this.hidScanner.start();
  }
  ionViewWillEnter(){
    if (this.screenData.name==='home') this.content.scrollToTop(0);
  }

  ionViewDidEnter(){
   this.state.currentScreen = this.screenData;
   if (this.screenData.name === 'home' && this.state.isSelfcheck && (!this.state.cordovaAvailable || this.state.physicalScanner) && !this.state.disableHomeScreenScanning){
      this.homeScreenScanning();
      console.log('home screen setting up scan');
    }
   this.analytics.trackPageView(this.state.currentScreen.title || this.state.currentScreen.name);
  }

  ngOnDestroy() {
    if (this.screenData && this.screenData.settings && this.screenData.settings.isHomeScreen) {
      this.state.homeScreen = undefined;
    }
    this.events.unsubscribe('patronLoggedIn', this._handler);
    this.events.unsubscribe('homeScrollToTop');
  }
  // ionViewCanLeave(){
  //   console.log('stacklength', this.navCtrl.length() )
  //   if (this.navCtrl.length() === 1){
  //     console.log('wee woo')
  //   }
    // if (this.checkForLogout){
    //   if (this.state.loggedInPatronId){
    //     this.forcePatronLogout()
    //     return false
    //   } else {
    //     return true
    //   }
    // }
  // }
  // forcePatronLogout(){
  //   console.log('we need to logout')
  // }

}



// WEBPACK FOOTER //
// ./src/pages/screen/screen.ts